module.exports = __webpack_public_path__ + "static/media/auto.4fc50662.png";